import { LocalizedSmallParagraph, OptimusPlainLink } from '@mews-commander/ui';
import { IconName, Stack } from '@optimus-web/core';
import { LocalizedCurrencyValue } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { isCurrentEnterpriseGroupBillingEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { getBillingGroupUrl, openGroupBillingModal } from '../../../../navigation/billing';
import { getReservationsTotalBalance } from './selectors';

interface TotalBalanceLabelProps {
    reservationId: string;
    groupId: string;
}

export const TotalBalanceLabel = ({ reservationId, groupId }: TotalBalanceLabelProps) => {
    const enterpriseId = useCurrentEnterpriseId();
    const dispatch = useCommanderThunkDispatch();

    const isGroupBilingEnabled = useCommanderSelector(isCurrentEnterpriseGroupBillingEnabled);
    const totalBalance = useCommanderSelector((state) =>
        getReservationsTotalBalance(state, {
            id: reservationId,
            enterpriseId,
        })
    );
    const href = useCommanderSelector((state) => getBillingGroupUrl(state, { groupId }));

    const openGroupBilling = () => dispatch(openGroupBillingModal({ groupId }));

    const totalCurrencyValue = <LocalizedCurrencyValue value={totalBalance} />;

    return (
        <Stack distribution="space-between" itemAlignment="center">
            <LocalizedSmallParagraph textKey={TextKey.ToBePaid} />

            {isGroupBilingEnabled ? (
                <OptimusPlainLink
                    href={href}
                    dataTestId={DataTestId.SmartDetailTotalBalance}
                    onClick={openGroupBilling}
                    inherit
                    icon={IconName.ArrowRight}
                >
                    {totalCurrencyValue}
                </OptimusPlainLink>
            ) : (
                totalCurrencyValue
            )}
        </Stack>
    );
};
